(function () {
  if (window.MaxxCollectionFilters) {
    return;
  }

  var requestStateBySectionId = {};
  var stickyStateBySectionId = {};
  var mobileFiltersStateBySectionId = {};
  var stickyScrollFrame = null;
  var stickyViewportQuery = window.matchMedia('(min-width: 992px)');
  var mobileViewportQuery = window.matchMedia('(max-width: 991px)');
  var stickyOffsetTop = 78;
  var stickyOffsetBottom = 28;

  function getSectionSelector(sectionId) {
    return '[data-section-type="collection-template"][data-section-id="' + sectionId + '"]';
  }

  function getSectionRootFromNode(node) {
    return node && node.closest ? node.closest('[data-section-type="collection-template"][data-section-id]') : null;
  }

  function getFiltersRoot(sectionRoot) {
    return sectionRoot ? sectionRoot.querySelector('[data-collection-filters]') : null;
  }

  function getFiltersPanel(sectionRoot) {
    return sectionRoot ? sectionRoot.querySelector('[data-collection-filters-panel]') : null;
  }

  function getFiltersStack(sectionRoot) {
    return sectionRoot ? sectionRoot.querySelector('.collection-layout__filters-stack') : null;
  }

  function getSearchInput(sectionRoot) {
    var filtersRoot = getFiltersRoot(sectionRoot);
    return filtersRoot ? filtersRoot.querySelector('[data-collection-filters-search]') : null;
  }

  function getMobileToggle(sectionRoot) {
    var filtersRoot = getFiltersRoot(sectionRoot);
    return filtersRoot ? filtersRoot.querySelector('[data-collection-filters-mobile-toggle]') : null;
  }

  function getMobilePanel(sectionRoot) {
    var filtersRoot = getFiltersRoot(sectionRoot);
    return filtersRoot ? filtersRoot.querySelector('[data-collection-filters-mobile-panel]') : null;
  }

  function getMobileBackdrop(sectionRoot) {
    var filtersRoot = getFiltersRoot(sectionRoot);
    return filtersRoot ? filtersRoot.querySelector('[data-collection-filters-mobile-backdrop]') : null;
  }

  function getEmptyMessage(sectionRoot) {
    var filtersRoot = getFiltersRoot(sectionRoot);
    return filtersRoot ? filtersRoot.querySelector('[data-collection-product-search-empty]') : null;
  }

  function getForm(sectionRoot) {
    var filtersRoot = getFiltersRoot(sectionRoot);
    return filtersRoot ? filtersRoot.querySelector('.collection-native-filters__form') : null;
  }

  function getSortValueInput(sectionRoot) {
    var form = getForm(sectionRoot);
    return form ? form.querySelector('[data-collection-filters-sort-value]') : null;
  }

  function syncMobileFilters(sectionRoot) {
    var sectionId;
    var filtersRoot;
    var toggle;
    var panel;
    var backdrop;
    var isExpanded;

    if (!sectionRoot) {
      return;
    }

    filtersRoot = getFiltersRoot(sectionRoot);
    toggle = getMobileToggle(sectionRoot);
    panel = getMobilePanel(sectionRoot);
    backdrop = getMobileBackdrop(sectionRoot);

    if (!filtersRoot || !toggle || !panel) {
      return;
    }

    sectionId = sectionRoot.dataset.sectionId;
    isExpanded = Boolean(mobileFiltersStateBySectionId[sectionId]);

    if (!mobileViewportQuery.matches) {
      filtersRoot.classList.remove('is-mobile-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'false');
      if (backdrop) {
        backdrop.setAttribute('aria-hidden', 'true');
      }
      syncMobileLockState();
      return;
    }

    filtersRoot.classList.toggle('is-mobile-open', isExpanded);
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    panel.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');

    if (backdrop) {
      backdrop.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
    }

    syncMobileLockState();
  }

  function syncMobileLockState() {
    var sectionId;
    var hasOpenDrawer = false;

    if (mobileViewportQuery.matches) {
      for (sectionId in mobileFiltersStateBySectionId) {
        if (mobileFiltersStateBySectionId[sectionId]) {
          hasOpenDrawer = true;
          break;
        }
      }
    }

    document.documentElement.classList.toggle('collection-filters-mobile-open', hasOpenDrawer);
    document.body.classList.toggle('collection-filters-mobile-open', hasOpenDrawer);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function clearDynamicSticky(sectionRoot) {
    var sectionId;
    var filtersPanel = getFiltersPanel(sectionRoot);
    var filtersStack = getFiltersStack(sectionRoot);

    if (filtersPanel) {
      filtersPanel.style.minHeight = '';
    }

    if (!filtersStack) {
      return;
    }

    sectionId = sectionRoot ? sectionRoot.dataset.sectionId : null;

    if (sectionId && stickyStateBySectionId[sectionId]) {
      stickyStateBySectionId[sectionId].lastScrollY = window.scrollY || window.pageYOffset || 0;
      stickyStateBySectionId[sectionId].offset = 0;
    }

    filtersStack.style.position = '';
    filtersStack.style.top = '';
    filtersStack.style.bottom = '';
    filtersStack.style.left = '';
    filtersStack.style.width = '';
  }

  function applyDynamicSticky(sectionRoot) {
    var filtersRoot = getFiltersRoot(sectionRoot);
    var filtersPanel = getFiltersPanel(sectionRoot);
    var filtersStack = getFiltersStack(sectionRoot);
    var sectionId;
    var state;
    var scrollY;
    var viewportHeight;
    var stackHeight;
    var panelHeight;
    var panelRect;
    var panelTop;
    var panelBottom;
    var maxOffset;
    var topOffset;
    var bottomOffset;
    var direction;
    var fitsViewport;
    var isPinnedTop;
    var isPinnedBottom;

    if (
      !sectionRoot ||
      !filtersRoot ||
      !filtersPanel ||
      !filtersStack ||
      !stickyViewportQuery.matches ||
      !filtersRoot.classList.contains('collection-native-filters--sidebar')
    ) {
      clearDynamicSticky(sectionRoot);
      return;
    }

    sectionId = sectionRoot.dataset.sectionId;
    state = stickyStateBySectionId[sectionId] || {
      offset: 0,
      lastScrollY: window.scrollY || window.pageYOffset || 0
    };
    scrollY = window.scrollY || window.pageYOffset || 0;
    viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    stackHeight = filtersStack.offsetHeight;

    filtersPanel.style.minHeight = stackHeight + 'px';

    panelRect = filtersPanel.getBoundingClientRect();
    panelTop = panelRect.top + scrollY;
    panelHeight = Math.max(filtersPanel.offsetHeight, stackHeight);
    panelBottom = panelTop + panelHeight;
    maxOffset = Math.max(panelHeight - stackHeight, 0);

    if (maxOffset <= 0) {
      stickyStateBySectionId[sectionId] = {
        offset: 0,
        lastScrollY: scrollY
      };
      clearDynamicSticky(sectionRoot);
      return;
    }

    direction = scrollY >= state.lastScrollY ? 'down' : 'up';
    state.offset = clamp(state.offset, 0, maxOffset);
    topOffset = clamp(scrollY + stickyOffsetTop - panelTop, 0, maxOffset);
    bottomOffset = clamp(
      scrollY + viewportHeight - stickyOffsetBottom - stackHeight - panelTop,
      0,
      maxOffset
    );
    fitsViewport = stackHeight <= viewportHeight - stickyOffsetTop - stickyOffsetBottom;

    if (fitsViewport) {
      state.offset = topOffset;
    } else {
      if (direction === 'down' && bottomOffset > state.offset) {
        state.offset = bottomOffset;
      }

      if (direction === 'up' && topOffset < state.offset) {
        state.offset = topOffset;
      }
    }

    state.offset = clamp(state.offset, 0, maxOffset);
    state.lastScrollY = scrollY;
    stickyStateBySectionId[sectionId] = state;

    isPinnedTop = fitsViewport
      ? scrollY + stickyOffsetTop > panelTop && state.offset < maxOffset
      : Math.abs(state.offset - topOffset) < 1 && state.offset > 0 && scrollY + stickyOffsetTop < panelBottom;
    isPinnedBottom = !fitsViewport
      && Math.abs(state.offset - bottomOffset) < 1
      && state.offset < maxOffset
      && scrollY + viewportHeight - stickyOffsetBottom > panelTop;

    filtersStack.style.left = '';
    filtersStack.style.top = '';
    filtersStack.style.bottom = '';
    filtersStack.style.width = '';

    if (state.offset <= 0) {
      filtersStack.style.position = 'absolute';
      filtersStack.style.top = '0';
      filtersStack.style.width = '100%';
      return;
    }

    if (state.offset >= maxOffset) {
      filtersStack.style.position = 'absolute';
      filtersStack.style.top = maxOffset + 'px';
      filtersStack.style.width = '100%';
      return;
    }

    if (isPinnedBottom && !isPinnedTop) {
      filtersStack.style.position = 'fixed';
      filtersStack.style.bottom = stickyOffsetBottom + 'px';
      filtersStack.style.left = panelRect.left + 'px';
      filtersStack.style.width = panelRect.width + 'px';
      return;
    }

    if (isPinnedTop) {
      filtersStack.style.position = 'fixed';
      filtersStack.style.top = stickyOffsetTop + 'px';
      filtersStack.style.left = panelRect.left + 'px';
      filtersStack.style.width = panelRect.width + 'px';
      return;
    }

    filtersStack.style.position = 'absolute';
    filtersStack.style.top = state.offset + 'px';
    filtersStack.style.width = '100%';
  }

  function syncDynamicSticky() {
    stickyScrollFrame = null;

    document.querySelectorAll('[data-section-type="collection-template"][data-section-id]').forEach(function (sectionRoot) {
      applyDynamicSticky(sectionRoot);
    });
  }

  function requestDynamicStickySync() {
    if (stickyScrollFrame !== null) {
      return;
    }

    stickyScrollFrame = window.requestAnimationFrame(syncDynamicSticky);
  }

  function applyProductSearch(sectionRoot) {
    var searchInput = getSearchInput(sectionRoot);
    var emptyMessage = getEmptyMessage(sectionRoot);
    var productCards;
    var visibleProducts = 0;
    var query;

    if (!sectionRoot || !searchInput) {
      return;
    }

    query = searchInput.value.trim().toLowerCase();
    productCards = sectionRoot.querySelectorAll('#Collection .product-layout');

    productCards.forEach(function (productCard) {
      var titleElement = productCard.querySelector('.product-name');
      var skuElement = productCard.querySelector('.variant-sku');
      var titleText = titleElement ? titleElement.textContent.toLowerCase() : '';
      var skuText = skuElement ? skuElement.textContent.toLowerCase() : '';
      var matches = !query || titleText.indexOf(query) !== -1 || skuText.indexOf(query) !== -1;

      productCard.style.display = matches ? '' : 'none';

      if (matches) {
        visibleProducts += 1;
      }
    });

    if (emptyMessage) {
      emptyMessage.hidden = visibleProducts > 0 || query === '';
    }
  }

  function serializeForm(form) {
    var params = new URLSearchParams();
    var formData = new FormData(form);

    formData.forEach(function (value, key) {
      if (value !== '') {
        params.append(key, value);
      }
    });

    return params;
  }

  function buildBrowserUrl(basePath, params) {
    var query = params.toString();
    return basePath + (query ? '?' + query : '');
  }

  function setLoadingState(sectionRoot, isLoading) {
    if (sectionRoot) {
      sectionRoot.classList.toggle('is-filter-loading', isLoading);
    }
  }

  function replaceSectionPanels(sectionRoot, html) {
    var parser = new DOMParser();
    var parsedDocument = parser.parseFromString(html, 'text/html');
    var nextSectionRoot = parsedDocument.querySelector(getSectionSelector(sectionRoot.dataset.sectionId));
    var currentFiltersPanel;
    var nextFiltersPanel;
    var currentResultsPanel;
    var nextResultsPanel;

    if (!nextSectionRoot) {
      throw new Error('Collection section markup was not found in AJAX response.');
    }

    currentFiltersPanel = sectionRoot.querySelector('[data-collection-filters-panel]');
    nextFiltersPanel = nextSectionRoot.querySelector('[data-collection-filters-panel]');
    currentResultsPanel = sectionRoot.querySelector('[data-collection-results-panel]');
    nextResultsPanel = nextSectionRoot.querySelector('[data-collection-results-panel]');

    if (currentFiltersPanel && nextFiltersPanel) {
      currentFiltersPanel.innerHTML = nextFiltersPanel.innerHTML;
    }

    if (currentResultsPanel && nextResultsPanel) {
      currentResultsPanel.innerHTML = nextResultsPanel.innerHTML;
    }
  }

  function requestSection(sectionRoot, browserUrl, options) {
    var settings = options || {};
    var requestUrl = new URL(browserUrl, window.location.origin);
    var sectionId = sectionRoot.dataset.sectionId;
    var requestState = requestStateBySectionId[sectionId] || {};
    var searchValue = '';
    var requestId;

    if (!sectionRoot) {
      return Promise.resolve();
    }

    if (requestState.controller) {
      requestState.controller.abort();
    }

    requestState.controller = new AbortController();
    requestState.requestId = (requestState.requestId || 0) + 1;
    requestId = requestState.requestId;
    requestStateBySectionId[sectionId] = requestState;
    requestUrl.searchParams.set('section_id', sectionId);

    if (settings.preserveSearch !== false) {
      var currentSearchInput = getSearchInput(sectionRoot);
      searchValue = currentSearchInput ? currentSearchInput.value : '';
    }

    setLoadingState(sectionRoot, true);

    return fetch(requestUrl.toString(), {
      method: 'GET',
      signal: requestState.controller.signal,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Collection filter request failed.');
        }

        return response.text();
      })
      .then(function (html) {
        replaceSectionPanels(sectionRoot, html);

        if (settings.skipHistory !== true) {
          window.history.pushState({}, '', browserUrl);
        }

        if (settings.preserveSearch !== false) {
          var nextSearchInput = getSearchInput(sectionRoot);

          if (nextSearchInput) {
            nextSearchInput.value = searchValue;
          }
        }

        applyProductSearch(sectionRoot);

        if (window.MaxxCollectionAjaxinate && typeof window.MaxxCollectionAjaxinate.init === 'function') {
          window.MaxxCollectionAjaxinate.init();
        }

        if (window.MaxxCollectionView && typeof window.MaxxCollectionView.applyStoredPreference === 'function') {
          window.MaxxCollectionView.applyStoredPreference();
        }

        syncMobileFilters(sectionRoot);
        requestDynamicStickySync();
      })
      .catch(function (error) {
        if (error.name === 'AbortError') {
          return;
        }

        window.location.assign(browserUrl);
      })
      .finally(function () {
        var latestState = requestStateBySectionId[sectionId];

        if (latestState && requestId === latestState.requestId) {
          setLoadingState(sectionRoot, false);
          latestState.controller = null;
        }
      });
  }

  function submitFilters(sectionRoot) {
    var form = getForm(sectionRoot);

    if (!form) {
      return;
    }

    requestSection(sectionRoot, buildBrowserUrl(form.action, serializeForm(form)));
  }

  function initializeSection(sectionRoot) {
    var sectionId;

    if (!sectionRoot) {
      return;
    }

    sectionId = sectionRoot.dataset.sectionId;

    if (typeof mobileFiltersStateBySectionId[sectionId] === 'undefined') {
      mobileFiltersStateBySectionId[sectionId] = false;
    }

    syncMobileFilters(sectionRoot);
    applyProductSearch(sectionRoot);

    if (window.MaxxCollectionAjaxinate && typeof window.MaxxCollectionAjaxinate.init === 'function') {
      window.MaxxCollectionAjaxinate.init();
    }

    requestDynamicStickySync();
  }

  function initializeAllSections() {
    document.querySelectorAll('[data-section-type="collection-template"][data-section-id]').forEach(function (sectionRoot) {
      initializeSection(sectionRoot);
    });
  }

  document.addEventListener('input', function (event) {
    var sectionRoot;

    if (!event.target.matches('[data-collection-filters-search]')) {
      return;
    }

    sectionRoot = getSectionRootFromNode(event.target);

    if (sectionRoot) {
      applyProductSearch(sectionRoot);
    }
  });

  document.addEventListener('change', function (event) {
    var sectionRoot = getSectionRootFromNode(event.target);
    var sortValueInput;

    if (!sectionRoot) {
      return;
    }

    if (event.target.matches('.collection-native-filters__form input[type="checkbox"]')) {
      submitFilters(sectionRoot);
      return;
    }

    if (event.target.matches('[data-collection-filters-sort]')) {
      sortValueInput = getSortValueInput(sectionRoot);

      if (sortValueInput) {
        sortValueInput.value = event.target.value;
      }

      submitFilters(sectionRoot);
    }
  });

  document.addEventListener('keydown', function (event) {
    var sectionRoot;

    if (!event.target.matches('.collection-native-filters__form input[type="number"]') || event.key !== 'Enter') {
      return;
    }

    sectionRoot = getSectionRootFromNode(event.target);

    if (!sectionRoot) {
      return;
    }

    event.preventDefault();
    submitFilters(sectionRoot);
  });

  document.addEventListener('submit', function (event) {
    var sectionRoot;

    if (!event.target.matches('.collection-native-filters__form')) {
      return;
    }

    sectionRoot = getSectionRootFromNode(event.target);

    if (!sectionRoot) {
      return;
    }

    event.preventDefault();
    submitFilters(sectionRoot);
  });

  document.addEventListener('click', function (event) {
    var actionLink = event.target.closest('.collection-native-filters__tag, .collection-native-filters__clear, .collection-native-filters__reset');
    var sectionRoot = getSectionRootFromNode(event.target);
    var mobileToggle = event.target.closest('[data-collection-filters-mobile-toggle]');
    var mobileClose = event.target.closest('[data-collection-filters-mobile-close]');
    var mobileBackdrop = event.target.closest('[data-collection-filters-mobile-backdrop]');
    var sectionId;

    if (mobileToggle || mobileClose || mobileBackdrop) {
      sectionRoot = getSectionRootFromNode(mobileToggle || mobileClose || mobileBackdrop);

      if (!sectionRoot) {
        return;
      }

      event.preventDefault();
      sectionId = sectionRoot.dataset.sectionId;

      if (mobileClose || mobileBackdrop) {
        mobileFiltersStateBySectionId[sectionId] = false;
      } else {
        mobileFiltersStateBySectionId[sectionId] = !mobileFiltersStateBySectionId[sectionId];
      }

      syncMobileFilters(sectionRoot);
      requestDynamicStickySync();
      return;
    }


    if (!actionLink || !sectionRoot) {
      return;
    }

    event.preventDefault();
    requestSection(sectionRoot, actionLink.href);
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-section-type="collection-template"][data-section-id]').forEach(function (sectionRoot) {
      requestSection(sectionRoot, window.location.pathname + window.location.search, {
        skipHistory: true
      });
    });
  });

  window.addEventListener('scroll', requestDynamicStickySync, { passive: true });
  window.addEventListener('resize', requestDynamicStickySync);
  window.addEventListener('load', requestDynamicStickySync);

  if (stickyViewportQuery.addEventListener) {
    stickyViewportQuery.addEventListener('change', requestDynamicStickySync);
  } else if (stickyViewportQuery.addListener) {
    stickyViewportQuery.addListener(requestDynamicStickySync);
  }

  if (mobileViewportQuery.addEventListener) {
    mobileViewportQuery.addEventListener('change', initializeAllSections);
  } else if (mobileViewportQuery.addListener) {
    mobileViewportQuery.addListener(initializeAllSections);
  }

  window.MaxxCollectionFilters = {
    init: initializeAllSections,
    requestSection: requestSection,
    applyProductSearch: applyProductSearch,
    syncDynamicSticky: requestDynamicStickySync
  };

  document.addEventListener('DOMContentLoaded', initializeAllSections);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    document.querySelectorAll('[data-section-type="collection-template"][data-section-id]').forEach(function (sectionRoot) {
      var sectionId = sectionRoot.dataset.sectionId;

      if (!mobileFiltersStateBySectionId[sectionId]) {
        return;
      }

      mobileFiltersStateBySectionId[sectionId] = false;
      syncMobileFilters(sectionRoot);
    });
  });
})();
